import { useEffect, useState } from "react";
import api from "./api"; // Tu configuración base de Axios
import { useUserSuperEmpresa } from "../Context/AuthContext";
import { saveAs } from "file-saver";

export const useGetFlujoCaja = () => {
  const { Token } = useUserSuperEmpresa();
  const [flujocaja, setFlujoCaja] = useState([]);
  const [loadingFlujoCaja, setLoadingFlujoCaja] = useState(false);
  const [errorFlujoCaja, setErrorFlujoCaja] = useState(null);

  const fetchFlujoCaja = async () => {
    setLoadingFlujoCaja(true);
    try {
      const { data } = await api.get("/flujo-caja", {
        headers: { Authorization: `Bearer ${Token}` },
      });
      setFlujoCaja(data);
      setErrorFlujoCaja(null);
    } catch (error) {
      console.error("💥 Error al obtener FlujoCaja:", error);
      setErrorFlujoCaja(error.response?.data?.message || "Error al obtener FlujoCaja");
    } finally {
      setLoadingFlujoCaja(false);
    }
  };

  // 🔁 Cargar automáticamente al montar
  useEffect(() => {
    fetchFlujoCaja();
  }, []);

  return {
    flujocaja,
    loadingFlujoCaja,
    errorFlujoCaja,
    refetchFlujoCajas: fetchFlujoCaja, // para recargar manualmente
  };
};


/* flujo de caja rme */

export const useGetFlujoCajaRME = () => {
  const { Token } = useUserSuperEmpresa();
  const [flujocaja, setFlujoCaja] = useState([]);
  const [loadingFlujoCaja, setLoadingFlujoCaja] = useState(false);
  const [errorFlujoCaja, setErrorFlujoCaja] = useState(null);

  const fetchFlujoCaja = async () => {
    setLoadingFlujoCaja(true);
    try {
      const { data } = await api.get("/flujocajaRME", {
        headers: { Authorization: `Bearer ${Token}` },
      });
      setFlujoCaja(data);
      setErrorFlujoCaja(null);
    } catch (error) {
      console.error("💥 Error al obtener FlujoCaja:", error);
      setErrorFlujoCaja(error.response?.data?.message || "Error al obtener FlujoCaja");
    } finally {
      setLoadingFlujoCaja(false);
    }
  };

   const exportarFlujoCaja = async (periodos = []) => {
    const response = await api.get("/exportarFlujoCaja", {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
      params: {
        periodos,
      },
      responseType: "blob",
    });

    saveAs(
      response.data,
      `flujo_caja_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`
    );
  };


  useEffect(() => {
    fetchFlujoCaja();
  }, []);

  return {
    flujocaja,
    loadingFlujoCaja,
    errorFlujoCaja,
    refetchFlujoCajas: fetchFlujoCaja, 
    exportarFlujoCaja
  };
};




export const useGetEstadoResultado = () => {
  const { Token } = useUserSuperEmpresa();
  const [estadoResultado, setEstadoResultado] = useState([]);
  const [loadingEstadoResultado, setLoadingEstadoResultado] = useState(false);
  const [errorEstadoResultado, setErrorEstadoResultado] = useState(null);

  const fetchEstadoResultado = async () => {
    setLoadingEstadoResultado(true);
    try {
      const { data } = await api.get("/estadoResultado", {
        headers: { Authorization: `Bearer ${Token}` },
      });
      setEstadoResultado(data.periodos); // Solo tomamos los periodos, puedes ajustar según necesites
      setErrorEstadoResultado(null);
    } catch (error) {
      console.error("💥 Error al obtener Estado de Resultado:", error);
      setErrorEstadoResultado(
        error.response?.data?.message || "Error al obtener Estado de Resultado"
      );
    } finally {
      setLoadingEstadoResultado(false);
    }
  };

   const exportarEstadoResultado = async (periodos = []) => {
    const response = await api.get("/exportarEstadoResultado", {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
      params: {
        periodos,
      },
      responseType: "blob",
    });

    saveAs(
      response.data,
      `Estado_Resultado_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`
    );
  };


  // 🔁 Cargar automáticamente al montar
  useEffect(() => {
    fetchEstadoResultado();
  }, []);

  return {
    estadoResultado,
    loadingEstadoResultado,
    errorEstadoResultado,
    refetchEstadoResultado: fetchEstadoResultado, 
    exportarEstadoResultado
  };
};
